import styled from "styled-components";
import headerBg from "../../assets/images/headerBg.svg";

export const LandingContainer = styled.div`
  width: 100%;
  height: auto;
  overflow: hidden;
  /* position: absolute; */
  /* top: 0; */
  /* background: url(${headerBg}) no-repeat; */
  @media (max-width: 1300px) {
    /* background-size: 700px; */
  }
`;

//Main

export const BackgroundImage = styled.div`
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  @media (max-width: 1300px) {
    img {
      width: 700px;
    }
  }
  @media (max-width: 900px) {
    top: 50px;
    img {
      width: 500px;
    }
  }
  @media (max-width: 900px) {
    top: 0px;
    img {
      width: 400px;
    }
  }
  @media (max-width: 760px) {
    top: 200px;
    img {
      width: 500px;
    }
  }
  @media (max-width: 480px) {
    top: 224px;
    img {
      width: 300px;
    }
  }
`;

export const MainContainer = styled.main`
  /* width: 100%; */
`;

export const BannerSection = styled.section`
position: absolute;
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  @media (max-width: 760px) {
    display: none;
  }
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  /* width: 480px; */
  max-width: ${(props) => props.maxW};
  margin-top: 2rem;

  p {
    font-family: 50rem;
    font-size: 1.6rem;
    line-height: 3rem;
    color: var(--text-color);
  }

  @media (max-width: 760px) {
    width: unset;
    padding: 0 ${props => props.defP || "2rem"} !important;
  }

  @media (max-width: 550px) {
    margin-top: 0%;
    p {
      font-size: 1.3rem;
    }
  }
`;
export const CardContainer = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

export const PlusContainer = styled.section`
  /* width: 30%; */
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12rem;
  @media (max-width: 760px) {
    display: none;
  }
`;
export const PlusImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  & div:first-child {
    position: absolute;
    left: 100px;
    top: 0;
  }
  & div:nth-of-type(2) {
    position: absolute;
    left: 170px;
    top: 80px;
  }
  & div:nth-of-type(3) {
    position: absolute;
    left: 20px;
    top: 170px;
  }
`;
